import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ffa6f996&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ffa6f996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa6f996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffa6f996')) {
      api.createRecord('ffa6f996', component.options)
    } else {
      api.reload('ffa6f996', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ffa6f996&scoped=true&", function () {
      api.rerender('ffa6f996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GPLuc6szYyT9/JS/comp/GuestBox.vue"
export default component.exports